import { Component, inject, input, ViewEncapsulation } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { provideIcons, provideNgIconLoader, withCaching } from '@ng-icons/core';
import { heroXMark } from '@ng-icons/heroicons/outline';
import { IconComponent } from '../icon/icon.component';
import { HttpClient } from "@angular/common/http";

@Component({
  selector: 'app-dialog',
  standalone: true,
  imports: [IconComponent, MatDialogModule],
  templateUrl: './dialog.component.html',
  styleUrl: './dialog.component.scss',
  encapsulation: ViewEncapsulation.None,
  providers: [
    provideIcons({heroXMark}),
    provideNgIconLoader((name) => {
      const http = inject(HttpClient);
      return http.get(`/assets/icons/${name}.svg`, { responseType: 'text' });
    }, withCaching()),
  ]
})
export class DialogComponent {
  noCloseIcon = input(false);
  noActions = input(false);
  dialogRef = inject(MatDialogRef<DialogComponent>);

  close(result?: unknown) {
    this.dialogRef.close(result);
  }
}
